/* src/app/pages/amplify-auth/user-sign-in/user-sign-in.component.scss */
.disabled-link {
  pointer-events: none;
  opacity: 0.5;
  cursor: default;
}
.mat-mdc-form-field {
  display: block;
}
/*# sourceMappingURL=user-sign-in.component.css.map */
